var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElevation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6015 3.58512C17.7441 3.58512 17.0514 2.89241 17.0514 2.03499C17.0514 1.17758 17.7441 0.484863 18.6015 0.484863H26.3522C27.2096 0.484863 27.9023 1.17758 27.9023 2.03499V9.78563C27.9023 10.643 27.2096 11.3358 26.3522 11.3358C25.4948 11.3358 24.8021 10.643 24.8021 9.78563V5.77952L16.5961 13.9807C15.9905 14.5862 15.012 14.5862 14.4065 13.9807L9.25717 8.87978L2.64636 15.5308C2.04084 16.1363 1.05942 16.1363 0.453994 15.5308C-0.151331 14.9253 -0.151331 13.9468 0.453994 13.3412L8.20599 5.5906C8.81151 4.98508 9.79003 4.98508 10.3955 5.5906L15.5013 10.6915L22.6077 3.54152L18.6015 3.58512Z",
    fill: "#BCBCBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevation);
export default __webpack_public_path__ + "static/media/elevation.85cba1d4df3a0c0a52fbd28b18156e7d.svg";
export { ForwardRef as ReactComponent };